import React, { useEffect, useMemo, useState } from "react";
import DATEPICKER_OR from '../custom-form/custom-date-picker.component'
import moment from "moment";
import CustomSearchableSelectWrapper from "../custom-form/custom-searchable-select-wrapper.component";
import { MAX_LENGTH, MODAL_CUSTOM_MESSAGE } from "../../../constants/external-constants";
import Icons from "../../icon";
import { ConfirmationNotificationModal } from "../modal/confirmation-modal.component";
import { CONFIRMATION_VALUE } from "../../../utils/constant.utils";
import { NotificationModal } from "../modal/notification-modal.component";
import Translation from "../../common/translation/translation.component";
import { connect, useSelector } from "react-redux";
import { convertToFormatLocalDate } from "../../../utils/helpers.utils";
import { PaginationControl } from "../table/pagination-control";

const modalInitialValue = {
    showConfirmModal: false,
    modalMessage: '',
    modalTitle: '',
    key: 0
}

const initialNotifValue = {
    modalTitle: '',
    modalMessage: '',
    showNotif: false
}

const CrudTable = ({ ...props }) => {

    const [modalResponce, setModalResponce] = useState({
        modalInitialValue
    }
    );
    const [columnValues, setColumnValues] = useState({});
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'ascending' });
    const [startDate, setStartDate] = useState(null)
    const [notifModal, setNotifModal] = useState({ initialNotifValue })   
    const [editingRow, setEditingRow] = useState(null);
    const [formData, setFormData] = useState({});
    const [beforeValue, setBeforeValue] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const [validationErrors, setValidationErrors] = useState({});
    const visibleHeaders = Object.entries(props.headerTable[0] || {}).filter(
        ([, value]) => !value.hidden
    );
    const adminSetting = useSelector(state => state.adminSetting);

    const fieldConfig = props.fieldType.reduce((acc, field) => {
        acc[field.name] = field;
        return acc;
    }, {});

    const handleEdit = (key) => {

        const dataToRender = props.hasColumSort ? paginatedData : props.dataTable;

        const row = dataToRender.find((item) => item.Key === key);
        setEditingRow(key);
        setFormData({ ...row });
        setBeforeValue({ ...row });

        if (row.ValidDateFrom) {
            setStartDate(row.ValidDateFrom)
        }
    };

    const hasChanged = JSON.stringify(formData) !== JSON.stringify(beforeValue);

    const handleDelete = (key) => {
        setModalResponce({
            key: key,
            showConfirmModal: true,
            modalTitle: "Delete",
            modalMessage: `${props.customeDeleteMessage ? props.customeDeleteMessage : MODAL_CUSTOM_MESSAGE.delete}`
        })

    };

    const handleSave = (key) => {
        setModalResponce({
            key: key,
            showConfirmModal: true,
            modalTitle: "Update",
            modalMessage: MODAL_CUSTOM_MESSAGE.update_details
        })
    };

    const deleteDataTable = (key) => {
        props.handleDeleteData(key);
        setModalResponce(modalInitialValue);
    }

    const updateDatatable = (key) => {
        const dataToRender = props.hasColumSort ? paginatedData : props.dataTable;

        const errors = {};

        const cleanedFormData = { ...formData };


        Object.keys(cleanedFormData).forEach((field) => {
            if (fieldConfig[field]?.type === "number" && cleanedFormData[field] === "") {
                cleanedFormData[field] = "";
            }
        });


        props.fieldType.forEach((field) => {

            if ((field.required && !formData[field.name]) || (formData[field.name] === "NaN" && field.type === "number")) {
                errors[field.name] = "This field is required";
            }
        });

        if (Object.keys(errors).length > 0) {
            setValidationErrors(errors);

            return;
        }

        setValidationErrors({});

        const updatedData = dataToRender.map((item) =>
            item.Key === key ? { ...item, ...cleanedFormData } : item
        );

        if (props.customValidation) {
            const result = props.customValidation(key, updatedData);
            if (result) {
                setModalResponce(modalInitialValue);
                result.map((item) => (
                    errors[item] = "Invalid Data"
                ));
                setValidationErrors(errors);
                return
            }
            else {
                handleSave(key);
            }
        }
    };

    const updateTableValue = (key) => {
        const dataToRender = props.hasColumSort ? paginatedData : props.dataTable;
        const cleanedFormData = { ...formData };


        Object.keys(cleanedFormData).forEach((field) => {
            if (fieldConfig[field]?.type === "number" && cleanedFormData[field] === "") {
                cleanedFormData[field] = "";
            }
        });


        const updatedData = dataToRender.map((item) =>
            item.Key === key ? { ...item, ...cleanedFormData } : item
        );

        if (props.updateData) {
            props.updateData(key, updatedData)
        }
        setEditingRow(null);
        setModalResponce(modalInitialValue);
    }

    const handleCancel = () => {
        setEditingRow(null);
        setValidationErrors({});
        setFormData({});
    };


    const handleCloseNotif = () => {
        setNotifModal(initialNotifValue)
    }

    const handleTableUpdate = (btnType) => {
        if (btnType === CONFIRMATION_VALUE.Ok) {
            if (modalResponce.modalTitle.toLowerCase() === "update") {
                updateTableValue(modalResponce.key)
            }

            if (modalResponce.modalTitle.toLowerCase() === "delete") {
                deleteDataTable(modalResponce.key)
            }

        } else {
            setModalResponce(modalInitialValue)
        }
    }

    const handleChange = (e, propName) => {
        let { value } = e.target;
        const config = fieldConfig[propName];

        // If the field is empty, allow it (for user experience)
        if (value === "") {
            setFormData({ ...formData, [propName]: value });
            return;
        }

        // If decimal field
        if (config?.decimalPlaces && config?.numberType === "decimal") {
            // fallback to [18,2] or [18,5] based on isFiveDecimal
            const defaultScale = props.isFiveDecimal ? 5 : 2;
            const [precision, scale] = config.decimalPlaces || [18, defaultScale];

            if (!/^\d*\.?\d*$/.test(value)) {
                return;
            }

            const parts = value.split('.');
            const wholePart = parts[0];
            const decimalPart = parts[1];

            if (wholePart.length > precision) {
                return;
            }

            if (decimalPart && decimalPart.length > scale) {
                return;
            }

            setFormData({ ...formData, [propName]: value });
            return;
        }

        // Handle number fields
        if (fieldConfig[propName]?.type === "number") {
            // Choose scale based on isFiveDecimal
            const scale = props.isFiveDecimal ? 5 : 2;
            const precision = 18;

            // Build regex dynamically (allows only X decimals)
            const regex = new RegExp(`^\\d*\\.?\\d{0,${scale}}$`);
            if (!regex.test(value)) return;

            // Convert to number to remove leading zeros
            let numValue = parseFloat(value);

            // Max value depends on precision & scale
            const maxVal = parseFloat(
                '9'.repeat(precision - scale) + (scale > 0 ? '.' + '9'.repeat(scale) : '')
            );
            if (numValue > maxVal) return;

            // If valid, update form data
            setFormData({ ...formData, [propName]: value });
            return;
        }

        // Other types of fields (like text, etc.)
        setFormData({ ...formData, [propName]: value });
    };

    const handleDropdownChange = (selectedOption, propName, selectedValue, labelSelected) => {
        if (!selectedOption) return;

        const fieldConfig = props.fieldType.find((field) => field.name === propName);

        if (fieldConfig && fieldConfig.data) {
            const selectedData = fieldConfig.data.find(
                (option) => option.Key === selectedOption
            );

            if (selectedData) {
                const updatedFormData = { ...formData };

                updatedFormData[selectedValue] = selectedOption;
                updatedFormData[propName] = selectedData.Value;

                if (labelSelected) {
                    updatedFormData[labelSelected] = selectedData.Label
                }


                setFormData(updatedFormData);
            }
        }
    };

    const sortedData = useMemo(() => {
        if (props.onColumnClick) {
            // If parent handles sorting, return data as-is
            return [...props.dataTable];
        }

        let sortableItems = [...props.dataTable];
        if (sortConfig.key !== null) {
            sortableItems.sort((a, b) => {
                if (a[sortConfig.key] < b[sortConfig.key]) {
                    return sortConfig.direction === 'ascending' ? -1 : 1;
                }
                if (a[sortConfig.key] > b[sortConfig.key]) {
                    return sortConfig.direction === 'ascending' ? 1 : -1;
                }
                return 0;
            });
        }
        return sortableItems;
    }, [props.dataTable, sortConfig, props.onColumnClick]);

    const paginatedData = useMemo(() => {
        const startIndex = (currentPage - 1) * itemsPerPage;
        const endIndex = startIndex + itemsPerPage;
        return sortedData.slice(startIndex, endIndex);
    }, [sortedData, currentPage, itemsPerPage]);

    const handleSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction });

        if (props.onColumnClick) {
            props.onColumnClick(key, direction === 'ascending');
        }
    };

    const renderInputField = (fieldName, value, propName) => {
        const config = fieldConfig[fieldName];

        if (!config || editingRow === null) {
            return value;
        }
        const isError = validationErrors[propName];
        const originalRow = props.dataTable.find(item => item.Key === editingRow);
        const originalRateComponent = originalRow?.RateComponent || "";

        const isDisabledFields = props.disabledFields?.includes(propName);
        const isRateComponentInFormula = new RegExp(`\\[${originalRateComponent}\\]`, 'i').test(props.formula);
        const isDisabled = isDisabledFields && isRateComponentInFormula;

        const handleBlur = (e, propName) => {
            if (config.type === "number" && propName === "CostCodePercent") {
                const formattedValue = parseFloat(e.target.value);
                setFormData({ ...formData, [propName]: formattedValue });
            }
            else if (config.type === "number" && config.numberType === "decimal" && config.decimalPlaces) {
                let value = e.target.value;
                if (!value) return;

                const scale = config.decimalPlaces ? config.decimalPlaces[1] : 2;

                const formattedValue = parseFloat(value).toFixed(scale);
                
                setFormData({ ...formData, [propName]: formattedValue });
            }
            else if (config.type === "number" && config.numberType === "decimal") {
                let formattedValue = e.target.value;
                if (/^\d+(\.\d{1,2})?$/.test(formattedValue)) {
                    if (formattedValue.indexOf('.') >= 0) {
                        const parts = formattedValue.split('.');
                        formattedValue = parts[0] + '.' + parts[1].padEnd(2, '0');
                    } else {
                        formattedValue = formattedValue + '.00';
                    }
                }
                setFormData({ ...formData, [propName]: formattedValue });
            }
        };


        if (config.type.toLowerCase() === "searchabledropdown") {

            const dropdownOptions = config.data || [];
            const selectedValue = config.selected;
            const labelSelected = config.labelSelected;
            return (

                <CustomSearchableSelectWrapper
                    options={dropdownOptions}
                    selected={formData[selectedValue]}
                    onChange={(val) => handleDropdownChange(val, fieldName, selectedValue, labelSelected)}
                    fieldProp={propName}
                    displayOption={config.displayOption}
                    showLabel={config.showLabel}
                    isError={isError}
                    optionLabelKey={config.optionLabelKey ? config.optionLabelKey : {
                        Key: 'Key',
                        Value: 'Value',
                        Label: 'Label',
                    }}
                    requiredField={config.required || false}
                    maxLength={MAX_LENGTH.limit_100}
                    disabled={false}
                />

            );
        }

        if (config.type.toLowerCase() === "text") {
            return (
                <input
                    type="text"
                    value={formData[propName] || ""}
                    onChange={(e) => handleChange(e, propName)}
                    className={`table-input__field ${isError ? "border-red" : ""}`}
                    disabled={isDisabled}
                />
            );
        }

        if (config.type.toLowerCase() === "number") {

            return (
                <input
                    type="number"
                    value={formData[propName] || ""}
                    onChange={(e) => handleChange(e, propName)}
                    onBlur={(e) => handleBlur(e, propName)}
                    step={config.numberType === "decimal" ? "0.01" : "1"}
                    className={`table-input__field ${isError ? "border-red" : ""}`}
                />
            );
        }

        if (config.type === "date") {

            return (
                <DATEPICKER_OR
                    dateOnly={true}
                    minDate={(!config.startDate && startDate) ? new Date(startDate) : propName === 'ValidDateTo' ? formData.ValidDateFrom : null}
                    startDate={
                        (!config.startDate && startDate)
                            ? (formData[propName]
                                ? (new Date(formData[propName]) < new Date(startDate)
                                    ? setFormData({ ...formData, [propName]: null })
                                    : new Date(formData[propName]))
                                : null)
                            : (formData[propName]
                                ? new Date(formData[propName])
                                : null)
                    }
                    selectedDate={(selectedDate) => {
                        if (selectedDate) {
                            setFormData({ ...formData, [propName]: selectedDate });
                            if (config.startDate) {
                                setStartDate(selectedDate);
                            }
                        } else {
                            setFormData({ ...formData, [propName]: "" });
                            setStartDate(null);
                        }
                    }}
                    isDisable={false}
                    placeholder="Select a date"
                    customClass={isError ? "border-red" : ""}
                    removeBorder={true}
                />
            );
        }

        return value;
    };

    const renderData = (row, value) => {
        const config = fieldConfig[value.propName];
        if (config && config.type === "date") {
            return convertToFormatLocalDate(row[value.propName], adminSetting.activeDateFormat.Name)
        }
        return row[value.propName]
    }

    const areAllRowsSelected = props.dataTable?.length > 0 && (props.unselectedRows !== undefined ? props.unselectedRows?.length === 0 : props.selectedRows?.length === props.dataTable?.length);

   const dataToRender = props.hasColumSort 
       ? props.dataTable 
    : [...props.dataTable].sort((a, b) => {
        const priority = ['PASS_THRU', 'COUNTRY_VAT', 'HW_FEE'];
        const aIndex = priority.indexOf(a.RateComponent);
        const bIndex = priority.indexOf(b.RateComponent);
        if (aIndex === -1 && bIndex === -1) return 0;
        if (aIndex === -1) return 1;
        if (bIndex === -1) return -1;
        return aIndex - bIndex;
    });


    //Search Filter
    const onColumnSearch = (event, value) => {
        if(props.onColumnSearch)
        {
            props.onColumnSearch(value);
        }
    };

    const onColumnSearchChange=(e, key)=> {

        setColumnValues(prevColumnValues => ({
            ...prevColumnValues,
            [key]: e.target.value 
        }));
        if(props.onColumnSearchChange)
        {
            props.onColumnSearchChange(e, key);
        }

        if(e.target.value === "") onColumnSearch(e, key);
    };

    const handleBlur = (event, key) => {
        const value = event.target.value;
        if (beforeValue !== value) {
            if (props.onColumnSearchChange) {
                props.onColumnSearchChange(event, key);
            }
            onColumnSearch(event, key);
        }
    };

    const handleFocus = (event) => {
        setBeforeValue(event.target.value);
    };

    return (
        <>
            <div>             
                <div className={`margin-bottom-16i ${props.hasScroll ? 'overflow-auto' : ''}`}>
                    <table className={`details-view-table crud-table__container ${props.customClass}`}>
                        <thead>
                            <tr>
                                {
                                    props.hasCheckBox &&
                                    <th>
                                        <input
                                            type="checkbox"
                                            className="d-flex mx-auto d-block"
                                            checked={areAllRowsSelected}
                                            onChange={props.onSelectAllChange}
                                        />
                                    </th>
                                }
                                {visibleHeaders.map(([key, value]) => (
                                    <th key={key}>
                                        <div className="d-flex align-items-center" onClick={() => handleSort(value.propName)}>
                                            {value.name}
                                            {
                                                props.hasColumSort &&
                                                <div className="icon-sorting">
                                                    {
                                                        sortConfig.key === value.propName ?
                                                            sortConfig.direction === "ascending" ?
                                                                <Icons
                                                                    name="sort-down-solid"
                                                                    size="14px"
                                                                    customClassName="icon-table-header"
                                                                    containerClass="d-inline-block" />
                                                                :
                                                                <Icons
                                                                    name="sort-up-solid"
                                                                    size="14px"
                                                                    customClassName="icon-table-header"
                                                                    containerClass="d-inline-block" />
                                                            :
                                                            <>
                                                                <Icons
                                                                    name="sort-up-solid"
                                                                    size="14px"
                                                                    customClassName="icon-table-header"
                                                                    containerClass="d-inline-block" />
                                                                <Icons
                                                                    name="sort-down-solid"
                                                                    size="14px"
                                                                    customClassName="icon-table-header margin-left-neg14-i"
                                                                    containerClass="d-inline-block" />
                                                            </>
                                                    }
                                                </div>
                                            }
                                        </div>
                                        {
                                            props.isColSearchShow &&
                                            <div className="thead-table-custom-filter" >
                                                <input
                                                    type="text"
                                                    placeholder="Search..."
                                                    maxLength={255}
                                                    name={'thead-column-search-' + value.propName}
                                                    value={columnValues[value.propName] || value.searchString || ''}
                                                    onChange={e => { onColumnSearchChange(e, value.propName) }}
                                                    onBlur={(e) => handleBlur(e, value.propName)}
                                                    onFocus={(e) => handleFocus(e)}
                                                    onKeyUp={(e) => {
                                                        if (e.key === 'Enter') {
                                                            onColumnSearch(e, value.propName);
                                                        }
                                                    }}
                                                />
                                            </div>
                                        }

                                    </th>
                                ))}
                                {props.haveDeleteAndEditBtn ?
                                    props.dataTable.length !== 0 &&
                                    <th className="table-btn__container"></th>
                                    : null
                                }
                            </tr>
                        </thead>
                        <tbody>
                            {
                                dataToRender.length !== 0 ?
                                    dataToRender.map((row) => (
                                        <tr key={row.Key}>
                                            {
                                                props.hasCheckBox &&
                                                <td>
                                                    <input
                                                        className="d-flex mx-auto d-block"
                                                        type="checkbox"
                                                        checked={props.selectedRows.includes(row.Key)}
                                                        onChange={() => props.onCheckboxChange(row.Key)}
                                                    />
                                                </td>
                                            }

                                            {visibleHeaders.map(([key, value]) => (
                                                <td key={key}>
                                                    {editingRow === row.Key
                                                        ? renderInputField(value.propName, formData[value.propName], value.propName)
                                                        : renderData(row, value)}
                                                </td>
                                            ))}
                                            {props.haveDeleteAndEditBtn ?
                                                <td>
                                                    {editingRow === row.Key ? (
                                                        <div className="edit-btn-container update-btn-container">
                                                            <div className="update-icon-container">
                                                                <Icons
                                                                    customClassName="icon-xmark-reg"
                                                                    name="xmark"
                                                                    size="20px"
                                                                    containerClass="icon-circle-plus-container"
                                                                    onClick={handleCancel}
                                                                />

                                                                <Icons
                                                                    customClassName={`icon-check-reg ${!hasChanged ? 'disabled' : ''}`}
                                                                    name="check"
                                                                    size="20px"
                                                                    containerClass="icon-circle-plus-container"
                                                                    onClick={hasChanged ? () => updateDatatable(row.Key) : null}
                                                                />
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <>
                                                            <div className="update-icon-container">
                                                                {
                                                                    (!props.hideDeleteBtn && (!props.hideDeleteBtnByIndex?.includes(row.Key))) &&
                                                                    <Icons
                                                                        customClassName={`icon-trash ${new RegExp(`\\[${row.RateComponent}\\]`, 'i').test(props.formula) ? 'disabled' : ''}`}
                                                                        name="trash-can"
                                                                        size="20px"
                                                                        containerClass="icon-circle-plus-container"
                                                                        onClick={() => {
                                                                            if (!new RegExp(`\\[${row.RateComponent}\\]`, 'i').test(props.formula)) {
                                                                                handleDelete(row.Key);
                                                                            }
                                                                        }}
                                                                    />
                                                                }
                                                                {
                                                                    (!props.hideEditBtn && (!props.hideEditBtnByIndex?.includes(row.Key))) &&
                                                                    <Icons
                                                                        customClassName="icon-pen-light"
                                                                        name="pen-light"
                                                                        size="20px"
                                                                        containerClass="icon-circle-plus-container"
                                                                        onClick={() => handleEdit(row.Key)}
                                                                    />
                                                                }
                                                            </div>
                                                        </>
                                                    )}
                                                </td>
                                                : null
                                            }
                                        </tr>
                                    ))
                                    :
                                    <tr key={"tr-0"}>
                                        <td colSpan={visibleHeaders.length + 1}>
                                            <h4 className="table-no-results text-align-center">
                                                <Translation translationKey="no_data_available" />
                                            </h4>
                                        </td>
                                    </tr>
                            }

                        </tbody>
                    </table>
                </div>
                {
                    props.havePagination &&
                    <PaginationControl
                        pageIndex={props.pageList.PageIndex}
                        total={props.pages.TotalEntries}
                        pageSize={props.pageList.PageSize}
                        pageSizes={props.pages.PageSizes}
                        resizePage={props.resizePage}
                        changePage={props.paginationAction ? props.paginationAction : ()=>{}}
                    />
                }
            </div>
            <ConfirmationNotificationModal
                show={modalResponce.showConfirmModal}
                message={modalResponce.modalMessage}
                title={modalResponce.modalTitle}
                isDecisionModal={props.isDecisionModal}
                handleModal={(btnType) => handleTableUpdate(btnType)}
                customClass={'comment-notification-modal modal-text-bold'}
            />
            <NotificationModal
                show={notifModal.showNotif}
                title={notifModal.modalTitle}
                message={notifModal.modalMessage}
                handleModal={handleCloseNotif}
                customClass={'comment-notification-modal notification-footer modal-text-bold'}
            />
        </>
    );
};

export default CrudTable;
